import React from 'react'
// @ts-expect-error @types/react-redux will be added later
import {connect} from 'react-redux'
import {Outlet, useMatch} from 'react-router'
import {toggleSidebar} from '../../../../actions/sidebar'
import {QuizHeader} from '../../../../components/header/QuizHeader'
import {ReturnButtonContainer} from '../../../../components/header/ReturnButtonContainer'
import Page from '../../../../components/page/Page'
import {SCOPE_QUIZ_BUILD} from '../../../../constants'
import {getQuiz} from '../../../../common/selectors/appSync'
import {isSurvey} from '../../../../common/lib/quizType'
import {Navigation} from '../Navigation'

type TeacherLayoutProps = {
  assignmentSession: Record<string, unknown> | null
  platform: string
  returnToUrl: string
  toggleSidebar: () => void
  isSurvey: boolean
}

function PageHeader({
  assignmentSession,
  platform,
  returnToUrl,
  toggleSidebar,
  isSurvey,
}: TeacherLayoutProps) {
  const isBuildPage = useMatch('/build/:activeAssignmentId')

  return (
    // @ts-expect-error Typescript is not fully setup in this codebase and React types are not yet handled.
    <QuizHeader
      app={isBuildPage !== null ? 'building' : 'other'}
      contextUuid={assignmentSession?.contextUuid}
      hamburgerButtonClick={isBuildPage ? toggleSidebar : null}
    >
      <Navigation isSurvey={isSurvey} />
      <ReturnButtonContainer returnToUrl={returnToUrl} platform={platform} />
    </QuizHeader>
  )
}

function BaseTeacherLayout({
  assignmentSession,
  platform,
  returnToUrl,
  toggleSidebar,
  isSurvey,
}: TeacherLayoutProps) {
  return (
    // @ts-expect-error Typescript is not fully setup in this codebase and React types are not yet handled.
    <Page
      header={
        <PageHeader
          assignmentSession={assignmentSession}
          platform={platform}
          returnToUrl={returnToUrl}
          toggleSidebar={toggleSidebar}
          isSurvey={isSurvey}
        />
      }
    >
      <Outlet />
    </Page>
  )
}

// @ts-expect-error Typescript is not fully setup in this codebase and Redux types are not yet handled.
const mapStateToProps = state => {
  const quiz = getQuiz(state)
  const currentAssignmentIsSurvey = isSurvey(quiz?.quizType)

  return {
    assignmentSession: state.assignmentSessions[SCOPE_QUIZ_BUILD] || null,
    platform: state.context.platform,
    returnToUrl: state.context.returnToUrl,
    isSurvey: currentAssignmentIsSurvey,
  }
}

export const TeacherLayout = connect(mapStateToProps, {toggleSidebar})(BaseTeacherLayout)
